import React, { forwardRef } from 'react';
import { ArchetypeIllustration } from './ArchetypeIllustration';

/**
 * 1080 x 1920 Instagram Story card.
 * Rendered inline (off-screen) and rasterized to PNG via html-to-image.
 */
export const StoryCard = forwardRef(({ archetype }, ref) => {
  return (
    <div
      ref={ref}
      data-testid="story-card"
      style={{
        width: 1080,
        height: 1920,
        backgroundColor: '#E8E0D5',
        backgroundImage:
          'radial-gradient(900px 500px at 50% -10%, rgba(61, 56, 48, 0.14), transparent 60%),' +
          'radial-gradient(700px 420px at 100% 110%, rgba(184, 167, 143, 0.18), transparent 65%),' +
          'radial-gradient(400px 280px at 0% 60%, rgba(61, 56, 48, 0.10), transparent 70%)',
        color: '#3D3830',
        fontFamily: '"Alegreya", Georgia, serif',
        position: 'relative',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '120px 100px',
        boxSizing: 'border-box',
      }}
    >
      {/* Eyebrow label */}
      <div
        style={{
          fontSize: 28,
          letterSpacing: '0.28em',
          textTransform: 'uppercase',
          color: '#3D3830',
          fontWeight: 500,
          marginBottom: 24,
        }}
      >
        Birth Prep Style
      </div>

      {/* Tiny divider */}
      <div style={{ width: 44, height: 1, backgroundColor: '#B8A78F', marginBottom: 60 }} />

      {/* Featured illustration */}
      <div style={{ color: '#3D3830', marginBottom: 60 }}>
        <ArchetypeIllustration archetypeKey={archetype.key} size={560} />
      </div>

      {/* "You are" label */}
      <div
        style={{
          fontSize: 26,
          letterSpacing: '0.3em',
          textTransform: 'uppercase',
          color: '#3D3830',
          fontWeight: 500,
          marginBottom: 20,
        }}
      >
        You are
      </div>

      {/* Archetype name */}
      <div
        style={{
          fontFamily: '"Alegreya", Georgia, serif',
          fontSize: 140,
          lineHeight: 1,
          color: '#3D3830',
          fontWeight: 500,
          marginBottom: 24,
          textAlign: 'center',
        }}
      >
        {archetype.name}
      </div>

      {/* Profile line */}
      <div
        style={{
          fontSize: 22,
          letterSpacing: '0.32em',
          textTransform: 'uppercase',
          color: '#3D3830',
          fontWeight: 500,
          marginBottom: 52,
        }}
      >
        {archetype.profile}
      </div>

      {/* Tagline */}
      <div
        style={{
          fontFamily: '"Alegreya", Georgia, serif',
          fontStyle: 'italic',
          fontSize: 52,
          lineHeight: 1.28,
          color: '#6d655a',
          textAlign: 'center',
          maxWidth: 820,
          marginBottom: 60,
        }}
      >
        &ldquo;{archetype.tagline}&rdquo;
      </div>

      {/* Affirmation block */}
      <div
        style={{
          backgroundColor: '#3D3830',
          color: '#FFFFFF',
          borderRadius: 32,
          padding: '44px 56px',
          textAlign: 'center',
          maxWidth: 820,
          marginBottom: 'auto',
        }}
      >
        <div
          style={{
            fontSize: 16,
            letterSpacing: '0.32em',
            textTransform: 'uppercase',
            opacity: 0.9,
            marginBottom: 18,
            fontWeight: 500,
          }}
        >
          Affirmation
        </div>
        <div
          style={{
            fontFamily: '"Alegreya", Georgia, serif',
            fontStyle: 'italic',
            fontSize: 42,
            lineHeight: 1.35,
          }}
        >
          &ldquo;{archetype.affirmation}&rdquo;
        </div>
      </div>

      {/* Footer CTA */}
      <div style={{ textAlign: 'center', marginTop: 60 }}>
        <div
          style={{
            fontFamily: '"Alegreya", Georgia, serif',
            fontStyle: 'italic',
            fontSize: 30,
            color: '#6d655a',
            marginBottom: 12,
          }}
        >
          Take the quiz
        </div>
        <div
          style={{
            fontSize: 28,
            letterSpacing: '0.24em',
            textTransform: 'uppercase',
            color: '#3D3830',
            fontWeight: 500,
          }}
        >
          karamears.com
        </div>
      </div>
    </div>
  );
});

StoryCard.displayName = 'StoryCard';

export default StoryCard;
